import React from "react"
import Link from "../utils/link"
import { cn } from "../utils/cn"
import { MainLogo } from "./icons"
import { ArrowRight } from "./icons"
import { getMenu, flattenMenus } from "../utils/menu"

function Header({ data }) {
  const [offCanvas, setOffCanvas] = React.useState(false)
  const [scrolled, setScrolled] = React.useState(false)
  const [direction, setDirection] = React.useState("down")

  const toggleOffcanvas = () => {
    setOffCanvas(!offCanvas)
  }

  let isScrolling
  let prevScroll = 0

  const onScroll = (e) => {
    let scr

    const curScroll = window.scrollY || document.scrollTop
    const windowHeight = window.innerHeight
    const documentHeight = document.documentElement.scrollHeight
    scr = curScroll > 1
    const dir = curScroll > prevScroll ? "down" : "up"

    // Make sure they scroll more than 5px
    if (Math.abs(prevScroll - curScroll) <= 5) return

    prevScroll = curScroll

    requestAnimationFrame(() => {
      setScrolled(scr)
      setDirection(dir)
    })
  }

  const scrollDetect = () => {
    window.clearTimeout(isScrolling)
    isScrolling = setTimeout(onScroll, 0)
  }

  React.useEffect(() => {
    window.addEventListener("scroll", scrollDetect, false)
    return () => {
      window.removeEventListener("scroll", scrollDetect, false)
    }
  }, [])

  let props = {
    onClick: () => {
      setOffCanvas(false)
    },
  }

  const menuLeft = getMenu(data, "headerLeft")
  const menuRight = getMenu(data, "headerRight")
  const menuMobile = flattenMenus(menuLeft, menuRight)

  const linkClass =
    "text-subheading-s1 font-[300] uppercase tracking-[2px] text-warmIvory"

  let headerClass = cn(
    "header fixed top-0 left-0 md:py-0 py-[20px] right-0 z-50 md:h-[108px] st-transition z-[51]",
    {
      "header--scrolled": scrolled,
      "translate-y-[-100%]": direction === "down" && scrolled,
      "header--off-canvas translate-y-[0]": offCanvas,
    }
  )

  const renderItems = (items) =>
    items.map((item) => (
      <li key={item.id}>
        <Link {...props} className={linkClass} to={item.path}>
          {item.label}
        </Link>
        {!!item.childItems?.length && (
          <ul>
            {item.childItems.map((child) => (
              <li key={child.id}>
                <Link {...props} className={linkClass} to={child.path}>
                  {child.label}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </li>
    ))

  return (
    <>
      <header className={headerClass}>
        <div className="inner flex justify-center md:justify-between items-center h-full">
          <div className="md:min-w-[375px] max-md:hidden">
            <nav>
              <ul className="md:flex items-center justify-between">
                {renderItems(menuLeft)}
              </ul>
            </nav>
          </div>

          <div className="md:min-w-[168px]">
            <Link {...props} className="header__logo" to="/">
              <MainLogo />
            </Link>
          </div>

          <div className="md:min-w-[375px] max-md:hidden">
            <nav>
              <ul className="md:flex items-center justify-between">
                {renderItems(menuRight)}
              </ul>
            </nav>
          </div>

          <button
            onClick={toggleOffcanvas}
            className="flex flex-col gap-[10px] absolute md:hidden top-[50%] translate-y-[-50%] right-[30px]"
          >
            <span className="line-top block w-[28px] h-[1px] bg-warmIvory st-transition"></span>
            <span className="line-bottom block w-[28px] h-[1px] bg-warmIvory st-transition"></span>
          </button>
        </div>
      </header>

      <div
        className={cn(
          "off-canvas h-screen pb-[75px] pt-[80px] bg-coral fixed top-0 left-0 right-0 z-50 translate-x-[-100%] st-transition",
          { "translate-x-0": offCanvas }
        )}
      >
        <div className="inner">
          <nav className="py-[44px]">
            <ul className="flex flex-col gap-[12px]">
              {menuMobile.map((item) => (
                <li key={item.id}>
                  <Link
                    {...props}
                    className="text-heading-h3 font-[300] font-heading text-plum"
                    to={item.path}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </>
  )
}

export default Header
